export const MONTHS_BM = ["Januari", "Februari", "Mac", "April", "Mei", "Jun", "Julai", "Ogos", "September", "Oktober", "November", "Disember"];
export const ROWS_PER_PAGE = 7;

export const fmtMasa = (hhmm) => {
  if (!hhmm) return "";
  const [h, m] = hhmm.split(":").map(Number);
  if (h < 12) return `${h}.${String(m).padStart(2, "0")} pg`;
  if (h === 12) return `12.${String(m).padStart(2, "0")} t/h`;
  if (h < 19) return `${h - 12}.${String(m).padStart(2, "0")} ptg`;
  return `${h - 12}.${String(m).padStart(2, "0")} mlm`;
};

export const fmtTarikh = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${Number(d)}.${Number(m)}.${y.slice(2)}`;
};

export function paginateMonths(months, fallbackMonth) {
  const list = months.length > 0 ? months : [{
    month: fallbackMonth, rows: [], jumlah_jarak: 0, jumlah_liter: 0, jumlah_rm: 0, kadar_kmpl: null,
  }];
  const pages = [];
  for (const m of list) {
    const chunks = [];
    for (let i = 0; i < Math.max(1, Math.ceil(m.rows.length / ROWS_PER_PAGE)); i++) {
      chunks.push(m.rows.slice(i * ROWS_PER_PAGE, (i + 1) * ROWS_PER_PAGE));
    }
    chunks.forEach((rows, i) => pages.push({ month: m.month, rows, isLast: i === chunks.length - 1, summary: m }));
  }
  return pages;
}

export const BUTIR_CSS = `
  .butir-doc { font-family: Arial, Helvetica, sans-serif; font-size: 12px; color: #000; }
  .butir-doc .sheet { width: 297mm; height: 210mm; background: #fff; padding: 8mm 10mm; box-sizing: border-box; display: flex; flex-direction: column; box-shadow: 0 4px 24px rgba(15,23,42,.18); overflow: hidden; }
  .butir-doc .bold { font-weight: bold; } .butir-doc .center { text-align: center; } .butir-doc .right { text-align: right; }
  .butir-doc .corner { text-align: right; font-size: 11px; line-height: 1.7; }
  .butir-doc .corner .pendua { font-weight: bold; font-size: 12px; }
  .butir-doc .dots { display: inline-block; min-width: 42mm; border-bottom: 1.4px dotted #000; }
  .butir-doc .dots-lg { display: inline-block; min-width: 90mm; border-bottom: 1.4px dotted #000; }
  .butir-doc .butir-title { text-align: center; font-size: 15px; font-weight: bold; letter-spacing: .4px; margin: 1mm 0 4mm; }
  .butir-doc .meta { font-size: 11px; margin-bottom: 1.6mm; }
  .butir-doc .meta .lbl { display: inline-block; min-width: 32mm; }
  .butir-doc .meta-row2 { display: flex; justify-content: space-between; align-items: baseline; gap: 6mm; }
  .butir-doc .grid-table { width: 100%; border-collapse: collapse; table-layout: fixed; }
  .butir-doc .grid-table th, .butir-doc .grid-table td { border: 1.2px solid #000; padding: 1mm 1.2mm; vertical-align: top; word-wrap: break-word; }
  .butir-doc .grid-table th { text-align: center; font-weight: bold; vertical-align: middle; font-size: 9px; line-height: 1.2; }
  .butir-doc .grid-table td { height: 9.5mm; font-size: 9px; line-height: 1.3; }
  .butir-doc .clamp3 { display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; }
  .butir-doc .clamp2 { display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
  .butir-doc .baki-note { font-size: 8px; text-align: center; line-height: 1.3; }
  .butir-doc .jumlah-row td { height: 7mm; vertical-align: middle; }
  .butir-doc .jumlah-row .lbl { font-weight: bold; text-align: right; padding-right: 3mm; }
  .butir-doc .kadar-heading { text-align: center; font-size: 11.5px; font-weight: bold; margin: 3mm 0 2mm; }
  .butir-doc .kadar-table th { font-size: 9.5px; }
  .butir-doc .kadar-table td { height: 9mm; font-size: 9.5px; vertical-align: middle; }
  .butir-doc .sah-cell { font-size: 9px; line-height: 1.7; vertical-align: top !important; }
  .butir-doc .sah-cell .k { display: inline-block; min-width: 22mm; }
  .butir-doc .nota-line { display: flex; gap: 14mm; font-size: 9.5px; margin-top: 1.6mm; }
  .butir-doc .sheet-footer { text-align: right; font-size: 10px; font-style: italic; margin-top: auto; }
`;

const dotted = (val, lg = false) => <span className={lg ? "dots-lg" : "dots"}><b>{val || "\u00a0"}</b></span>;

export function ButirSheet({ data, page, footer }) {
  const v = data.vehicle;
  const { month, rows, isLast, summary } = page;
  const monthLabel = `${MONTHS_BM[Number(month.slice(5)) - 1]} ${month.slice(0, 4)}`;
  const blanks = Math.max(0, ROWS_PER_PAGE - rows.length);
  return (
    <div className="sheet">
      <div className="corner">
        <div className="pendua">PENDUA</div>
        <div><b>No. Siri:</b> {dotted(data.no_siri)}</div>
      </div>
      <div className="butir-title">BUTIR- BUTIR PENGGUNAAN KENDERAAN</div>
      <div className="meta"><span className="lbl">BULAN/TAHUN</span>: {dotted(monthLabel)}</div>
      <div className="meta meta-row2">
        <span><span className="lbl">JENIS KENDERAAN</span>: {dotted(`${v.make} ${v.model}`)}</span>
        <span>NO. PENDAFTARAN : {dotted(v.registration_number)}</span>
        <span>BAHAGIAN/UNIT : {dotted(data.agency.bahagian || data.agency.name, true)}</span>
      </div>
      <table className="grid-table">
        <thead>
          <tr>
            <th rowSpan={2} style={{ width: "5%" }}>Tarikh</th>
            <th colSpan={2} style={{ width: "9%" }}>Masa</th>
            <th rowSpan={2} style={{ width: "8%" }}>Nama<br />Pemandu</th>
            <th rowSpan={2} style={{ width: "17.5%" }}>Tujuan dan Destinasi Perjalanan<br />(dari &ndash; ke)</th>
            <th rowSpan={2} style={{ width: "11%" }}>Nama dan Tandatangan<br />Pelulus</th>
            <th rowSpan={2} style={{ width: "11%" }}>Nama dan Tandatangan<br />Pengguna</th>
            <th rowSpan={2} style={{ width: "6%" }}>Bacaan<br />Odometer<br />(km)</th>
            <th rowSpan={2} style={{ width: "6%" }}>Jarak<br />Perjalanan/<br />Trip Meter<br />(km)</th>
            <th colSpan={2} style={{ width: "17.5%" }}>Pembelian Bahan Api<br />*Petrol/ Diesel/ Gas atau Pengecas<br />Elektrik</th>
            <th rowSpan={2} style={{ width: "9%" }}>Arahan Khas<br />Pengguna<br />Kenderaan</th>
          </tr>
          <tr>
            <th style={{ width: "4.5%" }}>Mulai</th>
            <th style={{ width: "4.5%" }}>Hingga</th>
            <th style={{ width: "12%" }}>No. Resit Pembelian &amp;<br />RM</th>
            <th style={{ width: "5.5%" }}>Liter/<br />Kilowatt</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i}>
              <td className="center">{fmtTarikh(r.tarikh)}</td>
              <td className="center">{fmtMasa(r.masa_mula)}</td>
              <td className="center">{fmtMasa(r.masa_tamat)}</td>
              <td><div className="clamp2">{r.pemandu}</div></td>
              <td><div className="clamp3">{r.tujuan}</div></td>
              <td><div className="clamp2">{r.pelulus}</div></td>
              <td><div className="clamp2">{r.pengguna}</div></td>
              <td className="center">{r.odo_mula != null ? (r.odo_tamat != null ? `${r.odo_mula}/ ${r.odo_tamat}` : `${r.odo_mula}`) : ""}</td>
              <td className="center">{r.jarak || ""}</td>
              <td className="center">
                {r.resit_no ? <>{r.resit_no}<br /></> : null}
                {r.resit_rm ? `RM ${Number(r.resit_rm).toFixed(2)}` : ""}
              </td>
              <td className="center">{r.liter ? `${r.liter} liter` : ""}</td>
              <td style={{ fontSize: "8.5px" }}>{r.arahan || ""}</td>
            </tr>
          ))}
          {Array.from({ length: blanks }).map((_, i) => (
            <tr key={`b${i}`}>
              {Array.from({ length: 9 }).map((__, j) => <td key={j}>&nbsp;</td>)}
              <td className={rows.length === 0 && i === 0 ? "baki-note" : ""}>
                {rows.length === 0 && i === 0 ? "Baki minyak dalam tangki pada setiap 1 haribulan dicatatkan setiap awal bulan." : "\u00a0"}
              </td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
          ))}
          {isLast && (
            <tr className="jumlah-row">
              <td colSpan={8} className="lbl">JUMLAH</td>
              <td className="center bold">{summary.jumlah_jarak || ""}</td>
              <td className="center bold">{summary.jumlah_rm ? `RM ${summary.jumlah_rm.toFixed(2)}` : ""}</td>
              <td className="center bold">{summary.jumlah_liter ? `${summary.jumlah_liter} liter` : ""}</td>
              <td></td>
            </tr>
          )}
        </tbody>
      </table>
      {isLast && (
        <>
          <div className="kadar-heading">KADAR PENGGUNAAN BAHAN API/ PENGECAS ELEKTRIK BULANAN</div>
          <table className="grid-table kadar-table">
            <tbody>
              <tr>
                <th style={{ width: "9%" }}>Bulan<br /><b>(a)</b></th>
                <th style={{ width: "15%" }}>Jumlah Jarak Perjalanan<br />(km)<br /><b>(b)</b></th>
                <th style={{ width: "18%" }}>Jumlah Penggunaan Bahan Api<br />(Liter/Kilowatt)<br /><b>(c)</b></th>
                <th style={{ width: "19%" }}>Jumlah Pembelian Bahan<br />Api/Pengecas Elektrik (RM)<br /><b>(d)</b></th>
                <th style={{ width: "19%" }}>Kadar Penggunaan Bahan Api<br />(km/ Liter@Kilowatt)<br /><b>(e)**</b></th>
                <th rowSpan={2} style={{ width: "20%" }} className="sah-cell">
                  <div style={{ textAlign: "left", fontWeight: "normal" }}>
                    <b>Disahkan Oleh</b><br />
                    <span className="k">Tandatangan</span>:<br />
                    <span className="k">Nama</span>:<br />
                    <span className="k">Jawatan</span>:<br />
                    <span className="k">Tarikh</span>:
                  </div>
                </th>
              </tr>
              <tr>
                <td className="center">{monthLabel}</td>
                <td className="center">{summary.jumlah_jarak} km</td>
                <td className="center">{summary.jumlah_liter} liter</td>
                <td className="center">RM {summary.jumlah_rm.toFixed(2)}</td>
                <td className="center">{summary.kadar_kmpl ?? "-"}</td>
              </tr>
            </tbody>
          </table>
          <div className="nota-line">
            <span>* potong yang tidak berkenaan</span>
            <span>** Formula Pengiraan (e) = (b) / (c)</span>
          </div>
        </>
      )}
      {footer && <div className="sheet-footer">{footer}</div>}
    </div>
  );
}
